import "core-js/modules/es6.number.constructor";
import Vue from 'vue';
import axios from 'axios';
import store from '@/store';
import { Message } from 'element-ui';
var baseURL = process.env.VUE_APP_API_BASE_URL;

// 创建 axios 实例
var service = axios.create({
  baseURL: baseURL,
  // api base_url
  timeout: 150000 // 请求超时时间
});
var err = function err(error) {
  if (error.response) {
    var data = error.response.data;
    var token = Vue.ls.get('ACCESS_TOKEN');
    if (error.response.code === 403) {
      Message.error(data.message);
    }
    if (error.response.code === 401 && !(data.result && data.result.isLogin)) {
      Message.error('Authorization verification failed');
      if (token) {
        store.dispatch('Logout').then(function () {
          setTimeout(function () {
            window.location.reload();
          }, 1500);
        });
      }
    }
  }
  return Promise.reject(error);
};

// request interceptor
service.interceptors.request.use(function (config) {
  var token = Vue.ls.get('ACCESS_TOKEN');
  var currentRoute = Vue.ls.get('SET_CUT_ROUTE');
  if (token) {
    config.headers['token'] = token; // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  config.headers['Login-Type'] = 'PC';
  config.headers['Cut_Route'] = currentRoute;
  return config;
}, err);

// response interceptor
service.interceptors.response.use(function (response) {
  var data = response.data;
  if (Number(data.code) === 401) {
    var token = Vue.ls.get('ACCESS_TOKEN');
    if (token) {
      store.dispatch('user/logout')["finally"](function () {
        setTimeout(function () {
          window.location.reload();
        }, 1500);
      });
    }
  } else {
    return response.data;
  }
}, err);
export default service;